import { AxiosError } from "axios";

export const errorHandler = (err: unknown) => {
  if (err instanceof AxiosError) {
    const status = err.response?.status;

    console.log(status);

    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      const currentPath = window.location.pathname;
      if (currentPath !== "/login") {
        window.location.href = "/login";
      }
    }

    throw new Error(err?.response?.data?.message || err.message);
  } else {
    throw err;
  }
};
